const DEFAULT_TEA_APP_ID = 345918;
const DEFAULT_THEME = "default";
const DEFAULT_APP_ID = 1988;
const DEFAULT_API_DOMAIN = "https://www.tiktok.com";
const DEFAULT_ENABLE_TEA = true;
const DEFAULT_LOCALE = "en";
const DEFAULT_TEA_CONFIG = {
  channel: "sg",
  channel_type: "tcpy"
};
export {
  DEFAULT_API_DOMAIN,
  DEFAULT_APP_ID,
  DEFAULT_ENABLE_TEA,
  DEFAULT_LOCALE,
  DEFAULT_TEA_APP_ID,
  DEFAULT_TEA_CONFIG,
  DEFAULT_THEME
};
